import { combineReducers } from "@reduxjs/toolkit";
import { authSlice } from "./auth/authSlice";
import { managementSlice } from "./management/managementSlice";
import { settingsSlice } from "./settings/settingsSlice";
import { workOrderSlice } from "./work-order/workOrderSlice";

const appReducer = combineReducers({
  auth: authSlice.reducer,
  settings: settingsSlice.reducer,
  management: managementSlice.reducer,
  workorder: workOrderSlice.reducer,
});

const rootReducer = (state: ReturnType<typeof appReducer> | undefined, action: any) => {
  if (action.type === "auth/logout") {
    state = undefined; // Reset all slices
  }
  return appReducer(state, action);
};

export default rootReducer;
